import { render, staticRenderFns } from "./TheModalLaboratorio.vue?vue&type=template&id=019988c6&"
import script from "./TheModalLaboratorio.vue?vue&type=script&lang=js&"
export * from "./TheModalLaboratorio.vue?vue&type=script&lang=js&"
import style0 from "./TheModalLaboratorio.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports